import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

const Nav = () => {
  const { count } = useCart();
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  return (
    <header className="erydon-nav" data-testid="main-nav">
      <Link to="/" className="erydon-logo" data-testid="logo-link">
        <span className="logo-mark">E</span>
        <span className="logo-text">ERYDON<span className="logo-slash">/</span>BIKES</span>
      </Link>

      <nav className="erydon-nav-links">
        <NavLink to="/" end className="nav-link" data-testid="nav-home">HOME</NavLink>
        {onHome ? (
          <a href="#bikes" className="nav-link" data-testid="nav-bikes">BIKES</a>
        ) : (
          <Link to="/#bikes" className="nav-link" data-testid="nav-bikes">BIKES</Link>
        )}
        {onHome ? (
          <a href="#scooters" className="nav-link" data-testid="nav-scooters">SCOOTERS</a>
        ) : (
          <Link to="/#scooters" className="nav-link" data-testid="nav-scooters">SCOOTERS</Link>
        )}
        {onHome ? (
          <a href="#about" className="nav-link" data-testid="nav-about">ABOUT</a>
        ) : (
          <Link to="/#about" className="nav-link" data-testid="nav-about">ABOUT</Link>
        )}
      </nav>

      <Link to="/cart" className="cart-button" data-testid="cart-button">
        <ShoppingCart size={16} strokeWidth={2.25} />
        <span>CART</span>
        {count > 0 && <span className="cart-badge" data-testid="cart-count">{count}</span>}
      </Link>
    </header>
  );
};

export default Nav;
